import { createActions } from 'redux-actions';
import { request } from '../../services';
import qs from 'qs';

const {
  fetchVendorTypesRequest,
  fetchVendorTypesSuccess,
  fetchVendorTypesFailure,
} = createActions(
  'FETCH_VENDOR_TYPES_REQUEST', 'FETCH_VENDOR_TYPES_SUCCESS', 'FETCH_VENDOR_TYPES_FAILURE',
);

export function fetchVendorTypes() {
  return (dispatch) => {
    dispatch(fetchVendorTypesRequest());
    return request('/api/line_items/vendor_types', { headers: { Accept: 'application/json' } })
      .then(({ json }) => dispatch(fetchVendorTypesSuccess(json.vendor_types)))
      .catch((errors) => {
        dispatch(fetchVendorTypesFailure({ errors }));
      });
  };
}

const {
  lineItemsRequest,
  lineItemsSuccess,
  lineItemsFailure,
} = createActions('LINE_ITEMS_SUCCESS', 'LINE_ITEMS_REQUEST', 'LINE_ITEMS_FAILURE');

export function requestLineItems() {
  return (dispatch, getState) => {
    dispatch(lineItemsRequest());
    const filterParams = qs.stringify(getState().lineItems.filters);
    return request(`line_items?${filterParams}`)
      .then(({ json }) => {
        dispatch(lineItemsSuccess(json));
      })
      .catch((error) => {
        dispatch(lineItemsFailure(error));
      });
  };
}

const {
  createLineItemRequest,
  createLineItemSuccess,
  createLineItemFailure,
} = createActions('CREATE_LINE_ITEM_SUCCESS', 'CREATE_LINE_ITEM_REQUEST', 'CREATE_LINE_ITEM_FAILURE');

export function createLineItem(lineItem) {
  return (dispatch) => {
    dispatch(createLineItemRequest());

    return request('line_items', { method: 'POST', body: lineItem })
      .then(({ json }) => {
        dispatch(createLineItemSuccess(json));
      })
      .catch((errors) => {
        dispatch(createLineItemFailure({ errors, line_item: lineItem }));
      });
  };
}

const {
  updateLineItemRequest,
  updateLineItemSuccess,
  updateLineItemFailure,
} = createActions('UPDATE_LINE_ITEM_SUCCESS', 'UPDATE_LINE_ITEM_REQUEST', 'UPDATE_LINE_ITEM_FAILURE');

export function updateLineItem(lineItem) {
  return (dispatch) => {
    dispatch(updateLineItemRequest());

    return request(`line_items/${lineItem.id}`, { method: 'PATCH', body: lineItem })
      .then(({ json }) => dispatch(updateLineItemSuccess(json)))
      .catch(errors => dispatch(updateLineItemFailure({ errors, line_item: lineItem })));
  };
}

export function setLineItemFilters(filter) {
  return dispatch => (
    Promise.all([
      dispatch({ type: 'LINE_ITEMS_SET_FILTERS', payload: filter }),
      dispatch(requestLineItems()),
    ])
  );
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/line_items.js